import { SVGProps } from "react";

export default function TimeIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#4B5563", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.2904 11.0417C17.2904 15.0667 14.0237 18.3333 9.9987 18.3333C5.9737 18.3333 2.70703 15.0667 2.70703 11.0417C2.70703 7.01667 5.9737 3.75 9.9987 3.75C14.0237 3.75 17.2904 7.01667 17.2904 11.0417Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.66669V10.8334"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 1.66669H12.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
